import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Header' })({
    root: {
        position: 'relative',
        display: 'flex',
        padding: 16,
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: '0 0 24px 24px',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        ['&:before']: {
            transition: 'opacity 0.3s',
            zIndex: -1,
            content: '""',
            position: 'absolute',
            inset: 0,
            backdropFilter: 'blur(16px)',
            borderRadius: '0 0 24px 24px',
            opacity: 0
        }
    },
    _gutterless: {
        marginLeft: -16,
        marginRight: -16
    },
    _blurry: {
        ['&:before']: {
            opacity: 1
        }
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '12px'
    }
});
